export const newColors = {
  brown: '#5B3150',
  brown30: '#CAB5BE',
  brown75: '#836077',
  pink: '#D647AA',
  backgroundPrimary: '#F9EEED',
  white: '#FFFFFF',
  yellow: '#FFCC00'
};